import {Component, input, output, OutputEmitterRef} from '@angular/core';
import {CovIconComponent, IconName} from '@cov/ui-angular';
import {TranslocoPipe} from '@jsverse/transloco';
import {DragDropDirective} from '../../directives/file-drag-drop.directive';
import {DragDropFileSelectError} from '../../enum/drag-drop-error.enum';
import {MimeType} from '../../enum/mime-type.enum';

@Component({
  selector: 'cov-drag-drop-file-select',
  imports: [CovIconComponent, DragDropDirective, TranslocoPipe],
  templateUrl: './drag-drop-file-select.component.html',
  styleUrl: './drag-drop-file-select.component.scss',
})
export class DragDropFileSelectComponent {
  protected readonly IconName = IconName;

  // INPUTS
  /**
   * The maximum file size in bytes.
   */
  public maxFileSize = input<number>();
  public allowedFormats = input<MimeType[]>([]);
  public allowedFormatsString = input<string>('');
  public allowedFileExtensions = input<string | null>(null);

  // OUTPUTS
  public filesDropped: OutputEmitterRef<FileList> = output();
  public fileError: OutputEmitterRef<DragDropFileSelectError> = output();

  // STATE

  protected onFilesDropped(fileList: FileList | null): void {
    if (!fileList) {
      return;
    }
    const files = Array.from(fileList);
    if (!this.checkFileSize(files)) {
      this.fileError.emit(DragDropFileSelectError.MAX_FILE_SIZE);
      return;
    }

    if (!this.checkFormat(files)) {
      this.fileError.emit(DragDropFileSelectError.UN_SUPPORTED_FORMAT);
      return;
    }

    this.filesDropped.emit(fileList);
  }

  private checkFileSize(files: File[]): boolean {
    const maxFileSize = this.maxFileSize();
    if (!maxFileSize) {
      return true;
    }
    return files.every((file) => file.size <= maxFileSize);
  }

  private checkFormat(files: File[]): boolean {
    const allowedFormats = this.allowedFormats();
    if (!allowedFormats) {
      return true;
    }

    return files.every((file: File) => allowedFormats.includes(file.type as MimeType));
  }
}
